import * as firebase from 'firebase/app';

const deploymentMap: Record<string, string> = {
  'reshub-aus-vacenti': 'splmuthjlq-uc',
  'reshub-test': '6cojktgehq-ew',
  'reshub': 'xov4bekkeq-uc',
  'reshub-eu': 'xov4bekkeq-uc',
  'reshub-us-1': '75xtlk2naa-uc'
};

export const getPcsAuthorizeUrl = () => {
    const projectId = firebase.app()?.options?.['projectId'];
    console.log('getPcsAuthorizeUrl() projectId:', projectId);
    
    if(projectId === 'reshub-test'){
        return 'https://inttestlogin.personcentredsoftware.com/connect/authorize'
    }
    else{
        return 'https://login.personcentredsoftware.com/connect/authorize'
    }
}

export const getDeploymentIdentifier = (): string => {
    const projectId = firebase.app()?.options?.['projectId'];
    console.log('getDeploymentIdentifier() projectId:', projectId);
    const identifier = deploymentMap[projectId ?? ''];

    if (!identifier) {
        console.warn(`No deployment identifier found for projectId: "${projectId}"`);
    }

    console.log('getDeploymentIdentifier() identifier:', identifier);

    return identifier || '';
};

export const getFunctionUrl = (functionName: string): string => {
    console.log('getFunctionUrl() functionName:', functionName);

    const identifier = getDeploymentIdentifier();
    const functionUrl = `https://${functionName}-${identifier}.a.run.app/`;

    console.log('getFunctionUrl() functionUrl:', functionUrl);
    return functionUrl;
};
